"use strict";

angular.module("vendor")
.constant("SUPPORT_EMAIL", "sales@wegotrade.com");



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative.constants.js
// module id = 864
// module chunks = 0